const KEY = "lc_cookie_consent_v1";

export const getConsent = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY));
  } catch {
    return null;
  }
};

export const saveConsent = (analytics) => {
  localStorage.setItem(KEY, JSON.stringify({ necessary: true, analytics, at: new Date().toISOString() }));
  window.dispatchEvent(new CustomEvent("lc:consent", { detail: { analytics } }));
};

export const openCookieSettings = () => window.dispatchEvent(new Event("lc:cookie-settings"));

// Analytics-ready: pushes to dataLayer only after explicit analytics consent.
export const track = (event, props = {}) => {
  if (!getConsent()?.analytics) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...props });
};
